export default {
  methods: {
    showSuccess(mensaje){
      this.$swal({
        title: "¡Buen trabajo!",
        text: mensaje,
        icon: "success",
        buttons: false,
        //timer: 15000
      });
    },
    showError(mensaje){
      this.$swal({
        html: '<pre>' + mensaje + '</pre>',
        customClass: {
          popup: 'format-pre'
        },
        title: "¡Ocurrió un error!",
        //text: mensaje,
        icon: "error",
        buttons: false,
        //timer: 15000
      });
    },
    showWarning(mensaje){
      this.$swal({
        title: "Atención",
        text: mensaje,
        icon: "warning",
        buttons: false,
        //timer: 15000
      });
    },
    showConfirmarDanger(mensaje, btnText){
      return this.$swal({
        reverseButtons: true,
        title: "Estas seguro?",
        //text: mensaje,
        html: '<pre>' + mensaje + '</pre>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c82333',
        cancelButtonColor: '#5a6268',
        confirmButtonText: btnText,
        cancelButtonText: 'Cancelar'
      });
    },
    showConfirmarInfo(titulo, mensaje, btnText){
      return this.$swal({
        reverseButtons: true,
        title: titulo,
        html: mensaje,
        //text: 'text' + mensaje,
        icon: 'info',
        showCancelButton: true,
        //confirmButtonColor: '#28a745',
        cancelButtonColor: '#5a6268',
        confirmButtonText: btnText,
        cancelButtonText: 'Cancelar'
      });
    },
    showConfirmarOnly(titulo, mensaje, btnText){
      return this.$swal({
        title: titulo,
        html: mensaje,
        icon: 'info',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: btnText,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
    showErrorOnly(mensaje){
      this.$swal({
        title: "¡Ocurrió un error!",
        text: mensaje,
        icon: "error",
        buttons: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/helpers/swalerts.js